import { daysSinceSite, recentAtSite, siteLabel } from "../lib/injections";
import { S } from "../theme";

function RecentAtSitePanel({ logs, siteId }) {
  const recent = recentAtSite(logs, siteId, 5);
  const ds = daysSinceSite(logs, siteId);
  return (
    <>
      <div style={{ fontSize: "0.95rem", fontWeight: 700, color: S.ink, marginBottom: 2 }}>{siteLabel(siteId)}</div>
      <div style={{ fontSize: "0.76rem", color: ds !== null && ds <= 2 ? S.accent2 : S.muted, marginBottom: 12 }}>
        {ds === null ? "Never used — fully rested" : ds === 0 ? "Used today" : `Last used ${ds} day${ds === 1 ? "" : "s"} ago`}
        {ds !== null && ds <= 2 ? " — consider another site" : ""}
      </div>
      <div style={{ fontSize: "0.68rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: S.muted, marginBottom: 8 }}>Recent here</div>
      {recent.length === 0 ? (
        <p style={{ fontSize: "0.8rem", color: S.muted, margin: 0 }}>No injections logged here yet.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {recent.map(l => (
            <div key={l.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.78rem", padding: "5px 0", borderBottom: `1px solid ${S.border}` }}>
              <span style={{ width: 7, height: 7, borderRadius: "50%", background: S.accent, flexShrink: 0 }} />
              <span style={{ color: S.ink2, fontWeight: 600 }}>{l.peptide || "—"}</span>
              <span style={{ marginLeft: "auto", color: S.muted, fontSize: "0.72rem" }}>{new Date(l.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

// ─── DAILY TRACKER ───────────────────────────────────────────

export { RecentAtSitePanel };
